/**
 * Online UI API
 * # Summary Elisa B2B Online UI API  # Usage This API is used in the `https://yrityksille.elisa.fi/` pages.  # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PunchoutOrderItem } from './punchoutOrderItem.js';
import { PunchoutOrderPunchoutRedeem } from './punchoutOrderPunchoutRedeem.js';
import { DeliveryAddress } from './deliveryAddress.js';


export interface PunchoutOrder { 
    /**
     * Request Id generated by the originating system.
     */
    punchoutRequestId: string;
    /**
     * Company share as defined in the Catalog for the ordered devices.
     */
    corporateShare?: number;
    orderItems?: Array<PunchoutOrderItem>;
    deliveryAddress?: DeliveryAddress;
    /**
     * Catalog GUID to which the products in the basket belong when employee orders.
     */
    catalogCode: string;
    /**
     * SF ID of the person billing account in case of OmaLaiteLasku order
     */
    personBillingAccountId?: string;
    /**
     * Count of Phone Subscriptions linked to the logged in user
     */
    usersPhoneSubscriptionCount?: number;
    /**
     * Whether user has selected total or partial delivery of items in the order. SFDC: Online_Order__c.Shipment_Type__c
     */
    shipmentType?: PunchoutOrder.ShipmentTypeEnum;
    punchoutRedeem?: PunchoutOrderPunchoutRedeem;
}
export namespace PunchoutOrder {
    export type ShipmentTypeEnum = 'TOTAL_DELIVERY' | 'PARTIAL_DELIVERY';
    export const ShipmentTypeEnum = {
        TOTAL_DELIVERY: 'TOTAL_DELIVERY' as ShipmentTypeEnum,
        PARTIAL_DELIVERY: 'PARTIAL_DELIVERY' as ShipmentTypeEnum
    };
}


